import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import StudyInfo from './views/StudyInfo.vue';
import PackageInfo from './views/PackageInfo.vue';
import SubscribeIntro from './views/SubscribeIntro.vue';
import ContactInfo from './views/ContactInfo.vue';
import StudySelection from './views/StudySelection.vue';
import PackageSelection from './views/PackageSelection.vue';
import ExperienceCenter from './views/ExperienceCenter.vue';
import SpeedDates from './views/SpeedDates.vue';
import CareerExpoOptions from './views/CareerExpoOptions.vue';
import InterviewingDaysOptions from './views/InterviewingDaysOptions.vue';
import Overview from './views/Overview.vue';

Vue.use(Router);

/* eslint-disable no-inline-comments */
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true,
    },
    {
      path: '/studies',
      name: 'studies',
      component: StudyInfo,
      props: true,
    },
    {
      path: '/packages',
      name: 'packages',
      component: PackageInfo,
      props: true,
    },
    {
      path: '/subscribe/intro',
      name: 'subscribe-intro',
      component: SubscribeIntro,
      props: true,
    },
    {
      path: '/subscribe/contact-information',
      name: 'contact-info',
      component: ContactInfo,
      props: true,
    },
    {
      path: '/subscribe/study-selection',
      name: 'study-selection',
      component: StudySelection,
      props: true,
    },
    {
      path: '/subscribe/package-selection',
      name: 'package-selection',
      component: PackageSelection,
      props: true,
    },
    {
      path: '/subscribe/experience-center',
      name: 'experience-center',
      component: ExperienceCenter,
      props: true,
    },
    {
      path: '/subscribe/speed-dates',
      name: 'speed-dates',
      component: SpeedDates,
      props: true,
    },
    {
      path: '/subscribe/career-expo-options',
      name: 'career-expo-options',
      component: CareerExpoOptions,
      props: true,
    },
    {
      path: '/subscribe/interviewing-days-options',
      name: 'interviewing-days-options',
      component: InterviewingDaysOptions,
      props: true,
    },
    {
      path: '/subscribe/overview',
      name: 'overview',
      component: Overview,
      props: true,
    },
  ],
});
